const date = new Date();

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const utcOffset = () => {
  return -date.getTimezoneOffset();
};

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const getTimeZoneShortName = () => {
  // You can pass undefined instead of en-us to default to the browser's current locale
  return date.toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];
};
